import { MoreHorizontal } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useCancelWatch } from "@/hooks/useWatches";
import type { Watch } from "@/types/watches";

/** Actions menu for a row in the Watches grid. Cancelled watches have no
 *  actions left, so the menu renders nothing for them. */
export function WatchRowMenu({ watch }: { watch: Watch }) {
  const cancel = useCancelWatch();
  if (!watch.active) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Row actions"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem
          destructive
          onSelect={() =>
            cancel.mutate(watch.id, {
              onSuccess: () => toast.success("Watch cancelled"),
              onError: () => toast.error("Could not cancel the watch"),
            })
          }
        >
          Cancel watch
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
